import { useT } from '@kmgestao/i18n';

export interface SupportFooterProps {
  /** Quando o footer está sobre fundo escuro (AuthShell com backgroundImage),
   * o link herda a cor branca do parent em vez de usar `text-primary`. */
  onDark?: boolean;
}

/** Footer de suporte exibido nos shells de auth ("Precisa de ajuda? email"). */
export function SupportFooter({ onDark }: SupportFooterProps = {}) {
  const { t } = useT('common');
  const linkClass = onDark
    ? 'font-medium underline hover:opacity-80'
    : 'font-medium text-primary hover:underline';
  return (
    <span>
      {t('support.helpLabel')}{' '}
      <a className={linkClass} href={t('support.emailHref')}>
        {t('support.emailLabel')}
      </a>
    </span>
  );
}
